import { statCards } from '../config';
import { GoalStatCard } from './goal-stat-card';
import { StatCard } from './stat-card';

import styles from './stats.module.css';

export function Stats({ values = {}, currency, overviewGoal, goalsCount = 0 }) {
	return (
		<div className={styles.statsGrid}>
			{statCards.map(card =>
				card.id === 'goal' && overviewGoal ? (
					<GoalStatCard
						key={card.id}
						card={card}
						goal={overviewGoal}
						otherGoalsCount={Math.max(0, goalsCount - 1)}
					/>
				) : (
					<StatCard
						key={card.id}
						card={card}
						value={values[card.id]}
						currency={currency}
					/>
				),
			)}
		</div>
	);
}
